export default __webpack_public_path__ + "static/media/signup_4.4b81d546.jpg";